import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlarm = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "alarm",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_15_3560",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 20,
			height: 20,
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Bounding box",
				width: 20,
				height: 20,
				fill: "#D9D9D9"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_15_3560)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "alarm_2",
				d: "M10 18.3333C8.95833 18.3333 7.98264 18.1354 7.07292 17.7396C6.16319 17.3437 5.37153 16.809 4.69792 16.1354C4.02431 15.4618 3.48958 14.6701 3.09375 13.7604C2.69792 12.8507 2.5 11.875 2.5 10.8333C2.5 9.79165 2.69792 8.81595 3.09375 7.90623C3.48958 6.99651 4.02431 6.20484 4.69792 5.53123C5.37153 4.85762 6.16319 4.3229 7.07292 3.92706C7.98264 3.53123 8.95833 3.33331 10 3.33331C11.0417 3.33331 12.0174 3.53123 12.9271 3.92706C13.8368 4.3229 14.6285 4.85762 15.3021 5.53123C15.9757 6.20484 16.5104 6.99651 16.9063 7.90623C17.3021 8.81595 17.5 9.79165 17.5 10.8333C17.5 11.875 17.3021 12.8507 16.9063 13.7604C16.5104 14.6701 15.9757 15.4618 15.3021 16.1354C14.6285 16.809 13.8368 17.3437 12.9271 17.7396C12.0174 18.1354 11.0417 18.3333 10 18.3333ZM12.3333 14.3333L13.5 13.1666L10.8333 10.5V6.66665H9.16667V11.1666L12.3333 14.3333ZM4.66667 1.95831L5.83333 3.12498L2.29167 6.66665L1.125 5.49998L4.66667 1.95831ZM15.3333 1.95831L18.875 5.49998L17.7083 6.66665L14.1667 3.12498L15.3333 1.95831ZM10 16.6666C11.625 16.6666 13.0035 16.1007 14.1354 14.9687C15.2674 13.8368 15.8333 12.4583 15.8333 10.8333C15.8333 9.20831 15.2674 7.82984 14.1354 6.6979C13.0035 5.56595 11.625 4.99998 10 4.99998C8.375 4.99998 6.99653 5.56595 5.86458 6.6979C4.73264 7.82984 4.16667 9.20831 4.16667 10.8333C4.16667 12.4583 4.73264 13.8368 5.86458 14.9687C6.99653 16.1007 8.375 16.6666 10 16.6666Z",
				fill: "#556C75"
			})
		})]
	})
});
export default SvgAlarm;
